import { render, staticRenderFns } from "./FormatAmount.vue?vue&type=template&id=18a476c7&scoped=true"
import script from "./FormatAmount.vue?vue&type=script&lang=js"
export * from "./FormatAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a476c7",
  null
  
)

export default component.exports